module.exports = __webpack_public_path__ + "static/media/close.10840ce9.svg";